import { useEffect, useState } from 'react';

export function useTmsSignInPolicy(enabled) {
  const [policy, setPolicy] = useState(null), [error, setError] = useState(null), [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!enabled) { setPolicy(null); setError(null); return undefined; }
    const abort = new AbortController(); let alive = true, refresh;
    const timeout = setTimeout(() => abort.abort(), 20000); setError(null);
    async function read() {
      const response = await fetch('/api/website/v3/sign-in/policy', { method: 'POST', credentials: 'same-origin', cache: 'no-store',
        redirect: 'error', signal: abort.signal, headers: { 'Content-Type': 'application/json' }, body: '{}' });
      const value = await response.json();
      if (!response.ok || !value || Object.keys(value).length !== 5 || value.contractId !== 'carrierflow.public-sign-in-policy/v3'
        || !['CONFIGURED', 'OWNER_SETUP'].includes(value.status) || !Array.isArray(value.allowedSignInProviders)
        || !value.allowedSignInProviders.length || value.allowedSignInProviders.length > 2
        || new Set(value.allowedSignInProviders).size !== value.allowedSignInProviders.length
        || !value.allowedSignInProviders.every(provider => ['password', 'google.com'].includes(provider))
        || typeof value.allowNewHumanRegistration !== 'boolean' || value.status === 'OWNER_SETUP' && value.allowNewHumanRegistration
        || !Number.isSafeInteger(value.expiresAtEpochMs) || value.expiresAtEpochMs <= Date.now()
        || value.expiresAtEpochMs > Date.now() + 30000) throw new Error('Account sign-in methods are unavailable. Refresh to try again.');
      if (!alive) return;
      setPolicy(value); refresh = setTimeout(() => { if (alive) setRevision(current => current + 1); }, Math.max(0, value.expiresAtEpochMs - Date.now() - 5000));
    }
    read().catch(() => { if (alive) { setPolicy(null); setError('Account sign-in methods are unavailable. Refresh to try again.'); } }).finally(() => clearTimeout(timeout));
    return () => { alive = false; abort.abort(); clearTimeout(timeout); clearTimeout(refresh); };
  }, [enabled, revision]);
  useEffect(() => {
    if (!policy) return undefined;
    const timer = setTimeout(() => setPolicy(current => current === policy ? null : current), Math.max(0, policy.expiresAtEpochMs - Date.now()));
    return () => clearTimeout(timer);
  }, [policy]);
  return { policy, error, refresh: () => setRevision(current => current + 1),
    allows: provider => enabled && policy?.status === 'CONFIGURED' && policy.expiresAtEpochMs > Date.now() && policy.allowedSignInProviders.includes(provider),
    registrationAllowed: enabled && policy?.status === 'CONFIGURED' && policy.expiresAtEpochMs > Date.now() && policy.allowNewHumanRegistration };
}
